// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 768 ? "228083d0" : chunkId) + "." + {"81":"a109664c0901708c","768":"5f04dd8063fe36d5"}[chunkId] + ".js";
};